module.exports = __webpack_public_path__ + "img/nature-1.7fc3bb43.jpg";